import { LOGOUT_SUCCESS, LOGOUT_SUCCESS_REDIRECT } from 'Screens/Login/actions/Actions';
import * as types from './types';
import initialState from './initialState';

function whatsNew (state = initialState, action) {
  switch (action.type) {
    case types.GET_WHATS_NEW_START: {
      return { ...state, isFetching: true, isUnavailable: false, error: null };
    }

    case types.GET_WHATS_NEW_SUCCESS: {
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        error: null,
        changelogUrl: action.changelogUrl,
        versions: action.versions
      };
    }

    case types.GET_WHATS_NEW_FAIL: {
      return {
        ...state, isFetching: false, isUnavailable: action.isPermanent, error: action.error
      };
    }

    case LOGOUT_SUCCESS:
    case LOGOUT_SUCCESS_REDIRECT: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}

export default whatsNew;
